export enum Role {
  Root = "root",
  Plataforma = "plataforma",
  Cliente = "cliente",
  Poryecto = "proyecto",
}
